// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".lov-management-container[data-v-3e108ab0]{padding:20px}.filter-card[data-v-3e108ab0],.header-card[data-v-3e108ab0]{margin-bottom:20px}.el-tag[data-v-3e108ab0]{font-weight:700}@media (max-width:768px){.lov-management-container[data-v-3e108ab0]{padding:10px}.el-dialog[data-v-3e108ab0]{width:90%!important}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
